import { jsx as _jsx } from "react/jsx-runtime";
import { Button, ButtonState, ButtonVariant } from '@as/cotopaxi';
import { Stack, useMediaQueryMatchesOnMobile } from '@yonderland/andes-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { ETICKET_CONSTANTS } from '../../../containers/EticketContainer';
export const EticketRatingButtons = ({ rateItem, rating }) => {
    const { t } = useTranslation(I18N_NAMESPACES.general);
    const isMobile = useMediaQueryMatchesOnMobile();
    const [voted, setVoted] = useState();
    const rateDivision = (rate) => {
        rateItem(rate);
        setVoted(rate);
    };
    const getButtonVariant = (ratingValue) => rating === ratingValue && !voted ? ButtonVariant.BRANDED : ButtonVariant.BASE;
    const ETICKET_BUTTONS = [
        {
            ratingValue: ETICKET_CONSTANTS.RATING.GOOD,
            text: t('eticket.rating.good'),
        },
        {
            ratingValue: ETICKET_CONSTANTS.RATING.OK,
            text: t('eticket.rating.okay'),
        },
        {
            ratingValue: ETICKET_CONSTANTS.RATING.BAD,
            text: t('eticket.rating.bad'),
        },
    ];
    return (_jsx(Stack, { gap: "5", direction: isMobile ? 'col' : 'row', children: ETICKET_BUTTONS.map(({ ratingValue, text }) => (_jsx(Button, { onClick: () => rateDivision(ratingValue), text: text, variant: getButtonVariant(ratingValue), state: voted ? ButtonState.FINISHED : ButtonState.INTERACTIVE, finisher: voted === ratingValue ? { text } : undefined }, ratingValue))) }));
};
